module.exports = __webpack_public_path__ + "img/giftcodes-screens-1-new.c82e247e.png";